// Copyright 2025-2026 NXGN Management, LLC. All Rights Reserved.
import {
  useMutation,
  useQueryClient,
  type UseMutationResult,
} from 'react-query'

import { changeGoldenStatus } from '@/services/templates'
import { Template } from '@/services/tcc/configurator'
import { queryKey as getTemplateQueryKey } from './useGetTemplate'
import { queryKey as getTemplatesQueryKey } from './useGetTemplates'

type Variables = {
  template: Template
  golden: boolean
}

export const useUpdateTemplateGoldenStatus = (): UseMutationResult<
  boolean,
  Error,
  Variables
> => {
  const queryClient = useQueryClient()

  return useMutation(
    ({ template, golden }) => changeGoldenStatus(template, golden),
    {
      onSuccess: async (_, { template }) => {
        await Promise.all([
          queryClient.invalidateQueries(getTemplateQueryKey(template.id)),
          queryClient.invalidateQueries(getTemplatesQueryKey),
        ])
      },
    }
  )
}
